import qualityEventsHelpers from '../quality-events.helpers';

export const REFERRALS_QUALITY_EVENTS = {
    referralAuthorLinkClipboard(referrerId: number | string) {
        qualityEventsHelpers.track({
            type: 'referral_author_link_clipboard',
            extra: String(referrerId)
        });
    },
    referralAuthorLinkShare(referrerId: number | string) {
        qualityEventsHelpers.track({
            type: 'referral_author_link_share',
            extra: String(referrerId)
        });
    },
    referralClickFaqLink(referrerId: number | string) {
        qualityEventsHelpers.track({
            type: 'referral_click_faq_link',
            extra: String(referrerId)
        });
    },
    referralSignupPageOpened(referrerId: number | string) {
        qualityEventsHelpers.track({
            type: 'referral_signup_page_opened',
            extra: String(referrerId)
        });
    },
    referralSignupSuccess(referrerId: number | string) {
        qualityEventsHelpers.track({
            type: 'referral_signup_success',
            extra: String(referrerId)
        });
    },
    referralClickAuthor(referrerId: number | string) {
        qualityEventsHelpers.track({
            type: 'referral_click_author',
            extra: String(referrerId)
        });
    },
    referralClickMaterial(material: Material, itemIndex: number, referrerId: number | string) {
        qualityEventsHelpers.track({
            ...qualityEventsHelpers.extractMaterialsData(material, { itemIndex }),
            type: 'referral_click_material',
            extra: String(referrerId)
        });
    },
    referralPromoActivated(referrerId: number | string) {
        qualityEventsHelpers.track({
            type: 'referral_promo_activated',
            extra: String(referrerId)
        });
    },
    referralPromoRedeemed(referrerId: number | string, orderId: number | string, freeMaterialId: number | string) {
        const extraData = {
            referrer_id: referrerId,
            order_id: orderId,
            free_material_id: freeMaterialId
        };

        qualityEventsHelpers.track({
            type: 'referral_promo_redeemed',
            extra: JSON.stringify(extraData)
        });
    },
};
